import { collection, query, getDocs, orderBy } from "firebase/firestore";
import { firestore } from "../firebase";

export const getHerramientasOnce = async (onDataChange) => {
    try {
        const herramientasCollection = collection(firestore, 'herramientas');
        const queryHerramientas = query(herramientasCollection, orderBy('id', 'asc'));
        const snapshot = await getDocs(queryHerramientas);
        const data = snapshot.docs.map(doc => doc.data());

        // Verificamos si el estado actual es un array o un objeto.
        onDataChange((prevState) => {
            if (Array.isArray(prevState)) {
                // Si el estado previo es un array, asumimos que es para setHerramientas.
                return data; // Sustituimos completamente el estado.
            } else if (typeof prevState === 'object' && prevState !== null) {
                // Si el estado previo es un objeto, asumimos que es para setState.
                // En materials es `materials`, aquí proveemos ambos por compatibilidad con la interfaz de remitos
                return { ...prevState, herramientas: data, materials: data };
            } else {
                console.error("Tipo de estado no compatible para `onDataChange`.");
                return prevState; // Devolvemos el estado sin modificar en caso de error.
            }
        });
    } catch (error) {
        console.error("Error al obtener los datos de herramientas:", error);
    }
};
